<div [ngClass]="showMore ? 'no-scroll' : ''">
    <app-navbar (setInformationDisplay)="setDisplay($event)"></app-navbar>
    <div id="site-content">
        <app-floating-contact [isShow]="showFloatingContact" *ngIf="showFloatingContact"></app-floating-contact>
        <router-outlet></router-outlet>
        <app-footer></app-footer>
    </div>
    <app-cookie *ngIf="showCookieBar" (showMoreEmitter)="onToggleShowMore($event)" [ngClass]="showMore ? 'more': ''"></app-cookie>
</div>
